/*
  DO NOT EDIT THIS FILE DIRECTLY.
  USE "npm run version:set" TO CHANGE THE VERSION
*/

export default '2.26.18';
